import script from "./index.vue?vue&type=script&lang=ts&setup=true"
export * from "./index.vue?vue&type=script&lang=ts&setup=true"

import "./styles/i-guidance.scss?vue&type=style&index=0&id=19e8c496&lang=scss&scoped=true"

import exportComponent from "/builds/client/whsomzu-group/inquiry-guide-mobile/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19e8c496"]])

export default __exports__